import React from 'react'
import styled from 'styled-components'

import { Box, Text } from '@usap/uicomponents'

const pageWidth = props => props.theme.global.size.pageWidth;
const borderColor = props => props.theme.global.colors['background-back'];
const whiteColor = props => props.theme.global.colors['white'];
const separatorColor = props => props.theme.global.colors['dark-4'];
const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');
const backgroundFrontColor = "#fff"

export const MainContainer = styled(Box)`
  width: ${pageWidth};
  margin: 0 auto;
  padding: 0 40px 16px;
  background: rgb(244, 244, 244);
  @media only screen and (min-device-width: 280px)  and (max-device-width: 540px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    padding: 0 16px 16px;
  }

`

export const Container = styled(Box)`
  margin-top: 16px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
    gap: 24px;
  }
`
export const OrderSummaryContainer = styled(Box)`
  background: ${whiteColor};
  border: solid 1px ${borderColor};
  border-radius: 4px;
  padding: 24px 16px;
  height: fit-content;
  gap: 34px;
  
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    align-self: flex-start;
    width: 343px;
  }

  @media only screen and (max-width: 1200px) {
    width: 280px;
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
`

export const OrderSummaryRow = styled.div`
  margin-bottom: 12px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const OrderDetailsContainer = styled(Box)`
  flex: 1;
`


export const OrderInformationBox = styled(Box)`
  background: ${whiteColor};
  flex-direction: column;
  border: solid 1px ${borderColor};
  border-radius: 4px;
  padding: 16px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {

  }
`

export const InformationBox = styled(Box)`
  padding: 0px;
  gap: 8px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
    gap: 6px;
  }
`
export const Border = styled.div`
  border: 0.5px solid ${borderColor};
  margin: 8px 0px;
`
export const Divider = styled.div`
  border: 0.5px solid ${borderColor};
  margin: 16px 0px;  
`
export const OrderDetailsDivider = styled.div`
  display: none;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    display: inherit;
    height: 100%;
    border: 1px solid ${separatorColor};
  }
`

export const PrintInvoiceBox = styled(Box)`
  margin-top: 16px;
  border: 1px solid #3E3E47;
  border-radius: 4px;
  height: 40px;
  width: 150px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const InformationTitleBox = styled(Box)`
  flex-direction: row;
  flex-wrap: wrap;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {

  }
`

export const OrdersContainer = styled(Box)`
  padding: 16px 0 0 0;
`

export const ToolTipContainer = styled(Box)`
  position: relative;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 12px;
`

export const ToolTip = styled(Box)`
  align-items: center;
  justify-content: center;
  width: 276px;
  height: 102px;
  border: solid 1px ${borderColor};
  background: ${whiteColor};
  position: absolute;
  left: 0;
  top: -110px;
  z-index: 9;
  border-radius: 4px;
  box-shadow: 1px 2px 5px 1px rgba(3, 3, 3, 0.2);
  max-width: unset;
`

export const ToolTipContent = styled(Text)`
  font-size: 12px;
  padding: 10px;
  line-height: 18px;
`

export const ToolTipArrow = styled(Box)`
  position: absolute;
  bottom: -22px;
  left: 46px;
`

export const SubTotalTipIcon = styled(Box)`
  position: absolute;
  left: 62px;
  cursor: pointer;
`

export const TrackPackageBtnContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 16px;
`

export const BackgroundColorWrapper = styled.div`
  background: rgb(244, 244, 244);
`

export const OrderDetailRecomWrapper = styled.div`
  padding-bottom: 24px;

  ${tabletBreakpoints} {
    padding: 0 12px 56px
  }
`

export const UptickWrapper = styled.div`
    background-color: ${backgroundFrontColor};
    border-radius: 4px;
    border: 1px solid #D4D4D6;
    margin:  ${props => props.isMobile ? '16px 0 0 0' : '0 0 16px 0'};
    
    &:not(:empty) {
        min-height: 150px;  
        ${props => props.theme.mediaQuery.down('mobile-landscape')} {
            min-height: 257px;  
        }
    }

    &:empty, &:has(> .uptick-flow-complete) {
        border: none;
        margin: 0;
        display: none;
    }
        
    & .uptick.uptick-inline {
        margin-top: 0;
    }
`